import { Role } from '~/common/providers/auth/role';

export const dataDownloadAllowedRoles: Role[] = [
  'LOGLASS_SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'CORP_PLANNING',
  'MANAGER',
  'GENERAL',
];
